// extracted by css-extract-rspack-plugin
module.exports =  {"label":"Label__label--NX5_g"};